import Loading from "./Loading";

function PrimaryButton({ children, buttonProps = {}, btnCls = "", isLoading }) {
  return (
    <button
      type="button"
      className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300 ${btnCls} ${
        buttonProps?.disabled || isLoading
          ? "opacity-70 cursor-not-allowed"
          : ""
      }`}
      {...buttonProps}
    >
      <div className="flex justify-center items-center">
        {isLoading ? <Loading /> : null}

        {children}
      </div>
    </button>
  );
}

export default PrimaryButton;
